import { envConfig } from '@/src/config/envConfig';
import { APP_ENV } from './environment';

const availableAppRoutes = {
  DCA: 'DCA',
  REWARDS: 'REWARDS',
  QUESTS: 'QUESTS',
  DOCUMENTATION: 'DOCUMENTATION',
  FEATURE_REQUEST: 'FEATURE_REQUEST',
  SCAN: 'SCAN',
  EXPLORER: 'EXPLORER',
  ECOSYSTEM: 'ECOSYSTEM',
  EARN: 'EARN',
  AI: 'AI',
  TRADE: 'TRADE',
  ZAPPING: 'ZAPPING',
  HISTORY: 'HISTORY',
  PORTFOLIO: 'PORTFOLIO',
} as const;

type AvailableAppRoutes = keyof typeof availableAppRoutes;

const APP_ROUTES: {
  [key in AvailableAppRoutes]: {
    title: string;
    link: string;
    id: string;
    positionLink?: string;
    addressLink?: string;
    txLink?: string;
    deploymentPhase?: string;
  };
} = {
  DCA: {
    title: 'DCA',
    id: 'DCA',
    link: '/dca',
    positionLink: '/dca/positions',
  },
  DOCUMENTATION: {
    title: 'Documentation',
    id: 'DOCUMENTATION',
    link: 'https://docs.dzap.io',
  },
  FEATURE_REQUEST: {
    title: 'Feature Request',
    id: 'FEATURE_REQUEST',
    link: 'https://features.dzap.io/',
  },
  REWARDS: {
    title: 'Rewards',
    link: '/rewards',
    id: 'REWARDS',
  },
  QUESTS: {
    title: 'Quests',
    link: '/quests',
    id: 'QUESTS',
  },
  SCAN: {
    title: 'Scan',
    link: '/scan',
    id: 'SCAN',
    addressLink: '/scan/address',
    txLink: '/scan/tx',
  },
  EXPLORER: {
    title: 'Explorer',
    link: '/explorer',
    id: 'EXPLORER',
    addressLink: '/explorer/address',
    txLink: '/explorer/tx',
  },
  ECOSYSTEM: {
    title: 'Ecosystem',
    link: '/ecosystem',
    id: 'ECOSYSTEM',
  },
  EARN: {
    title: 'Earn',
    link: '/earn',
    id: 'EARN',
  },
  HISTORY: {
    title: 'History',
    link: '/history',
    id: 'HISTORY',
  },
  AI: {
    title: 'ZapGPT',
    link: '/zapgpt',
    id: 'ai',
    deploymentPhase: 'Beta',
  },
  TRADE: {
    title: 'Trade',
    link: '/trade',
    id: 'trade',
  },
  ZAPPING: {
    title: 'Zapping',
    link: '/zap',
    id: 'zapping',
    deploymentPhase: 'Beta',
  },
  PORTFOLIO: {
    title: 'Portfolio',
    link: '/portfolio',
    id: 'portfolio',
  },
} as const;

export default APP_ROUTES;

const baseRoutes: AvailableAppRoutes[] = [
  availableAppRoutes.DOCUMENTATION,
  availableAppRoutes.REWARDS,
  availableAppRoutes.ECOSYSTEM,
  availableAppRoutes.EXPLORER,
];

export const hamburgerMenuImages = {
  DOCUMENTATION: '/assets/iconv2/document.svg',
  PORTFOLIO: '/assets/iconv2/portfolio.svg',
  REWARDS: '/assets/iconv2/document.svg',
  EXPLORER: '/assets/iconv2/explorer.svg',
  ECOSYSTEM: '/assets/iconv2/ecosystem.svg',
};

export const hamburgerMenuRoutes: AvailableAppRoutes[] =
  envConfig.appEnv === APP_ENV.STAGING ? [...baseRoutes, availableAppRoutes.PORTFOLIO] : baseRoutes;

// @dev: Make sure to update this list when adding testnet support for a route or when adding a new route that doesn't support testnet yet
export const pathnamesNotSupportingTestnet = [
  APP_ROUTES.ZAPPING.link,
  APP_ROUTES.EARN.link,
  APP_ROUTES.PORTFOLIO.link,
  APP_ROUTES.AI.link,
];

// @dev: Ghost (private) mode only works on these routes; it is force-disabled everywhere else.
export const pathnamesSupportingPrivateMode: string[] = [APP_ROUTES.TRADE.link];
